// extracted by mini-css-extract-plugin
module.exports = {"bullet":"avatar__bullet___1QHII","avatar":"avatar__avatar___19tBS","image":"avatar__image___388ow","letter":"avatar__letter___2ksIY"};